import API from '../api/axios';
/**
 * Gets all the cheese
 *
 * @returns All the cheese
 */
export const getCheeses = async () => {
    try {
        const cheeses = await API({ url: '/cheeses' });
        return cheeses;
    }
    catch (error) {
        return [];
    }
};
/**
 * Gets a specific cheese
 *
 * @returns A cheese
 */
export const getCheese = async (name) => {
    try {
        const cheese = await API({ url: `/cheese/${name}` });
        return cheese;
    }
    catch (error) {
        return {};
    }
};
/**
 * Gets a random cheese
 *
 * @returns A cheese
 */
export const getRandomCheese = async () => {
    try {
        const cheese = await API({ url: '/random' });
        return cheese;
    }
    catch (error) {
        return {};
    }
};
/**
 * Gets a random cheese
 *
 * @returns A cheese
 */
export const searchCheese = async (params) => {
    try {
        const cheese = await API({ url: '/search', params });
        return cheese;
    }
    catch (error) {
        return [];
    }
};
